exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-0e92a579{height:215px;resize:vertical}\n", ""]);

// Exports
exports.locals = {
	"input": "input-0e92a579"
};